{
    "RI6BS9DHg0IYU9xnNB5-d": {
        "position": {
            "x": 28,
            "y": 28,
            "z": 1
        },
        "direction": {
            "y": -1
        },
        "key": "RI6BS9DHg0IYU9xnNB5-d",
        "tag": "spawn"
    },
    "rsZK--kWP1jn-NUQLWcw9": {
        "position": {
            "x": 28,
            "y": 27,
            "z": 1
        },
        "direction": {
            "y": -1
        },
        "key": "rsZK--kWP1jn-NUQLWcw9",
        "tag": "spawn"
    },
    "PIhay7Bb1IUw4rLyzsj9-": {
        "position": {
            "x": 27,
            "y": 27,
            "z": 1
        },
        "direction": {
            "y": -1
        },
        "key": "PIhay7Bb1IUw4rLyzsj9-",
        "tag": "spawn"
    },
    "-AqNd96HfjbTzy5Pos-Jc": {
        "position": {
            "x": 27,
            "y": 28,
            "z": 1
        },
        "direction": {
            "y": -1
        },
        "key": "-AqNd96HfjbTzy5Pos-Jc",
        "tag": "spawn"
    },
    "Y-Z7lVYcu6VJFehOovG0Z": {
        "position": {
            "x": 16,
            "y": 22,
            "z": 1
        },
        "direction": {
            "y": -1
        },
        "key": "Y-Z7lVYcu6VJFehOovG0Z",
        "tag": "spawn"
    },
    "milCiZGstNU8eIZ0iIRkx": {
        "position": {
            "x": 15,
            "y": 22,
            "z": 1
        },
        "direction": {
            "y": -1
        },
        "key": "milCiZGstNU8eIZ0iIRkx",
        "tag": "spawn"
    },
    "oK8_sMgQFKKbcjyWDECyC": {
        "position": {
            "x": 16,
            "y": 21,
            "z": 1
        },
        "direction": {
            "y": -1
        },
        "key": "oK8_sMgQFKKbcjyWDECyC",
        "tag": "spawn"
    },
    "C_-tfZDR2rrbqgb-yv8Dm": {
        "position": {
            "x": 15,
            "y": 21,
            "z": 1
        },
        "direction": {
            "y": -1
        },
        "key": "C_-tfZDR2rrbqgb-yv8Dm",
        "tag": "spawn"
    },
    "jHbjvbuZgDyOHp1-dwdIz": {
        "position": {
            "x": 14,
            "y": 18,
            "z": 1
        },
        "direction": {
            "y": -1
        },
        "key": "jHbjvbuZgDyOHp1-dwdIz",
        "tag": "spawn"
    },
    "d5sRf2R3GeT1-2Bw_tTdS": {
        "position": {
            "x": 14,
            "y": 17,
            "z": 1
        },
        "direction": {
            "y": -1
        },
        "key": "d5sRf2R3GeT1-2Bw_tTdS",
        "tag": "spawn"
    },
    "efigHUS6QTptsYaxkvQC7": {
        "position": {
            "x": 13,
            "y": 17,
            "z": 1
        },
        "direction": {
            "y": -1
        },
        "key": "efigHUS6QTptsYaxkvQC7",
        "tag": "spawn"
    },
    "uq0t-UW7np9GEQ4jbAI4a": {
        "position": {
            "x": 15,
            "y": 17,
            "z": 1
        },
        "direction": {
            "y": -1
        },
        "key": "uq0t-UW7np9GEQ4jbAI4a",
        "tag": "spawn"
    },
    "q0YEWgG_Gym2XcqsPi6YJ": {
        "position": {
            "x": 15,
            "y": 11,
            "z": 1
        },
        "direction": {
            "y": -1
        },
        "key": "q0YEWgG_Gym2XcqsPi6YJ",
        "tag": "spawn"
    },
    "q6clCIqOwB2pN-g6GFW3q": {
        "position": {
            "x": 14,
            "y": 9,
            "z": 1
        },
        "key": "q6clCIqOwB2pN-g6GFW3q",
        "tag": "spawn-lava"
    },
    "ql3UTO7sW7ufvRRQyZJyJ": {
        "position": {
            "x": 15,
            "y": 10,
            "z": 1
        },
        "key": "ql3UTO7sW7ufvRRQyZJyJ",
        "tag": "spawn-lava"
    },
    "Yj3pO0kuIt_NBwgQ6k9P5": {
        "position": {
            "x": 15,
            "y": 7,
            "z": 1
        },
        "key": "Yj3pO0kuIt_NBwgQ6k9P5",
        "tag": "spawn-lava"
    },
    "IOpr4KSgkWZ_VytvjLD-7": {
        "position": {
            "x": 13,
            "y": 7,
            "z": 1
        },
        "key": "IOpr4KSgkWZ_VytvjLD-7",
        "tag": "spawn-lava"
    },
    "GWWrDfoZvwj6y04jT9TOO": {
        "position": {
            "x": 14,
            "y": 8,
            "z": 1
        },
        "key": "GWWrDfoZvwj6y04jT9TOO",
        "tag": "spawn-lava"
    },
    "YdEyLedLXEeIFo8tMxKpa": {
        "position": {
            "x": 15,
            "y": 9,
            "z": 1
        },
        "key": "YdEyLedLXEeIFo8tMxKpa",
        "tag": "spawn-lava"
    },
    "Ic2eLd_D58iec1DTp6OjR": {
        "position": {
            "x": 16,
            "y": 8,
            "z": 1
        },
        "key": "Ic2eLd_D58iec1DTp6OjR",
        "tag": "spawn-lava"
    },
    "QPNFL-ul4pAkBilBHQOiz": {
        "position": {
            "x": 14,
            "y": 10,
            "z": 1
        },
        "key": "QPNFL-ul4pAkBilBHQOiz",
        "tag": "spawn-lava"
    },
    "LnmVY1NDT8GDWV-M6ytjf": {
        "key": "LnmVY1NDT8GDWV-M6ytjf",
        "position": {
            "x": 19,
            "y": 10,
            "z": 1
        },
        "tag": "kill"
    },
    "KJ3GltuA9QEl79He4EQ8z": {
        "position": {
            "x": 13,
            "y": 8,
            "z": 1
        },
        "key": "KJ3GltuA9QEl79He4EQ8z",
        "tag": "spawn-lava"
    },
    "ZruO2SLqMwx08kGW127g3": {
        "position": {
            "x": 14,
            "y": 7,
            "z": 1
        },
        "key": "ZruO2SLqMwx08kGW127g3",
        "tag": "spawn-lava"
    },
    "Bpu7Xq6j4zZMWYOKGv635": {
        "position": {
            "x": 15,
            "y": 8,
            "z": 1
        },
        "key": "Bpu7Xq6j4zZMWYOKGv635",
        "tag": "spawn-lava"
    },
    "pLcndTXxeOVRS7n2knil0": {
        "position": {
            "x": 16,
            "y": 9,
            "z": 1
        },
        "key": "pLcndTXxeOVRS7n2knil0",
        "tag": "spawn-lava"
    },
    "dfWo964y0vDZBGd7rBgn_": {
        "position": {
            "x": 16,
            "y": 10,
            "z": 1
        },
        "key": "dfWo964y0vDZBGd7rBgn_",
        "tag": "spawn-lava"
    },
    "SynrDJdNHVD0MbUK5mYni": {
        "position": {
            "x": 13,
            "y": 9,
            "z": 1
        },
        "key": "SynrDJdNHVD0MbUK5mYni",
        "tag": "spawn-lava"
    },
    "U6MdcfFJrBEYA0RU3llrx": {
        "position": {
            "x": 17,
            "y": 9,
            "z": 1
        },
        "key": "U6MdcfFJrBEYA0RU3llrx",
        "tag": "spawn-lava"
    },
    "HyOkGb4vtHxMOv4Fari0P": {
        "position": {
            "x": 17,
            "y": 8,
            "z": 1
        },
        "key": "HyOkGb4vtHxMOv4Fari0P",
        "tag": "spawn-lava"
    },
    "U4fXlkNq29elLmBj_DsTa": {
        "position": {
            "x": 12,
            "y": 8,
            "z": 1
        },
        "key": "U4fXlkNq29elLmBj_DsTa",
        "tag": "spawn-lava"
    },
    "nQ2owCoFPJmf0U0pIvZS2": {
        "position": {
            "x": 13,
            "y": 10,
            "z": 1
        },
        "key": "nQ2owCoFPJmf0U0pIvZS2",
        "tag": "spawn-lava"
    },
    "oM6HR0wPclJJ1E_NbJxIv": {
        "position": {
            "x": 15,
            "y": 12,
            "z": 1
        },
        "key": "oM6HR0wPclJJ1E_NbJxIv",
        "tag": "spawn"
    },
    "eu0L5nY6SOhc0oXIzKmx0": {
        "position": {
            "x": 14,
            "y": 11,
            "z": 1
        },
        "key": "eu0L5nY6SOhc0oXIzKmx0",
        "tag": "spawn"
    },
    "YkD8XtPiYAmn1SYrbr_MB": {
        "position": {
            "x": 14,
            "y": 12,
            "z": 1
        },
        "key": "YkD8XtPiYAmn1SYrbr_MB",
        "tag": "spawn"
    }
}